var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1 1H12.9C14.0598 1 15 1.89543 15 3V9.66667C15 10.7712 14.0598 11.6667 12.9 11.6667H12.2V13.6667C12.1986 13.9358 12.0274 14.1777 11.766 14.28C11.6829 14.3173 11.5918 14.3356 11.5 14.3333C11.3139 14.3344 11.1351 14.2648 11.003 14.14L8.413 11.6667H3.1C1.9402 11.6667 1 10.7712 1 9.66667V3C1 1.89543 1.9402 1 3.1 1ZM12.9002 10.3334C13.2868 10.3334 13.6002 10.0349 13.6002 9.66671V3.00004C13.6002 2.63185 13.2868 2.33337 12.9002 2.33337H3.10017C2.71357 2.33337 2.40017 2.63185 2.40017 3.00004V9.66671C2.40017 10.0349 2.71357 10.3334 3.10017 10.3334H8.70017C8.88623 10.3323 9.06507 10.4019 9.19717 10.5267L10.8002 12.06V11C10.8002 10.6319 11.1136 10.3334 11.5002 10.3334H12.9002Z",
    fill: "#1F2B22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H11",
    stroke: "#1F2B22",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H11",
    stroke: "#1F2B22",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage2);
export default __webpack_public_path__ + "static/media/message2.0906a98e6ed74c4809abc94fed6e0f0a.svg";
export { ForwardRef as ReactComponent };